"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Assignation_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveAssignations = exports.isAssignationActive = exports.Assignation = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const uuid_1 = require("uuid");
const orm_1 = require("../orm");
const statusGetter_1 = require("../statusGetter");
const transformOrderIdToBookingReference_1 = require("../transformers/transformOrderIdToBookingReference");
const transformToDate_1 = require("../transformers/transformToDate");
const AssignationAutomaticEmail_1 = require("./AssignationAutomaticEmail");
let Assignation = Assignation_1 = class Assignation extends orm_1.CDBaseEntity {
    constructor() {
        super(...arguments);
        this._id = (0, uuid_1.v4)();
        this.createdAt = new Date();
        this.rentalVehicle = null;
        this.subsidyIds = [];
        this.compensationIds = [];
        this.penaltyIds = [];
        this.automaticEmails = [];
        this.taxFeeCoefficient = 0;
        this.invoiceId = null;
        this.version = 0;
    }
    get status() {
        return (0, statusGetter_1.statusGetter)(this, Assignation_1, legacy_enums_1.AssignationStatus);
    }
    static statusPrototype(status) {
        const defined = new Date();
        switch (status) {
            case legacy_enums_1.AssignationStatus.Cancelled:
                return {
                    cancelledAt: defined,
                };
            case legacy_enums_1.AssignationStatus.Declined:
                return {
                    declinedAt: defined,
                };
            case legacy_enums_1.AssignationStatus.Accepted:
                return {
                    acceptedAt: defined,
                    cancelledAt: undefined,
                    declinedAt: undefined,
                };
            case legacy_enums_1.AssignationStatus.Pending:
            default:
                return {
                    cancelledAt: undefined,
                    declinedAt: undefined,
                    acceptedAt: undefined,
                };
        }
    }
    get orderConfirmationCode() {
        return (0, transformOrderIdToBookingReference_1.transformOrderIdToBookingReference)(this.orderId);
    }
};
exports.Assignation = Assignation;
__decorate([
    (0, orm_1.CDObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Assignation.prototype, "_id", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Assignation.prototype, "createdAt", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Assignation.prototype, "orderId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Assignation.prototype, "rideId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Assignation.prototype, "orderDepartureAt", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Assignation.prototype, "price", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Assignation.prototype, "fee", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Assignation.prototype, "userId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Assignation.prototype, "vehicleType", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((a) => a.status === legacy_enums_1.AssignationStatus.Accepted && !a.acceptationNote && (0, utils_1.isUndefinedOrNull)(a.rentalVehicle)),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => value ?? undefined),
    __metadata("design:type", String)
], Assignation.prototype, "vehicleId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((a) => a.status === legacy_enums_1.AssignationStatus.Accepted && !a.vehicleId && (0, utils_1.isUndefinedOrNull)(a.rentalVehicle)),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => value ?? undefined),
    __metadata("design:type", String)
], Assignation.prototype, "acceptationNote", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Assignation.prototype, "rentalVehicle", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], Assignation.prototype, "subsidyIds", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], Assignation.prototype, "compensationIds", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], Assignation.prototype, "penaltyIds", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Assignation.prototype, "acceptedAt", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Assignation.prototype, "declinedAt", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Assignation.prototype, "cancelledAt", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => value ?? undefined),
    __metadata("design:type", String)
], Assignation.prototype, "reason", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Assignation.prototype, "cancellationInfo", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => AssignationAutomaticEmail_1.AssignationAutomaticEmail),
    __metadata("design:type", Array)
], Assignation.prototype, "automaticEmails", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Assignation.prototype, "taxFeeCoefficient", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Assignation.prototype, "invoiceId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Assignation.prototype, "assignationOfferClaimId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Assignation.prototype, "assignationOfferId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Assignation.prototype, "comboAssignationOfferId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Assignation.prototype, "version", void 0);
exports.Assignation = Assignation = Assignation_1 = __decorate([
    (0, orm_1.CDEntity)("assignations")
], Assignation);
const isAssignationActive = (assignation) => legacy_enums_1.activeAssignationStatuses.includes(assignation.status);
exports.isAssignationActive = isAssignationActive;
const getActiveAssignations = (assignations) => assignations.filter(exports.isAssignationActive);
exports.getActiveAssignations = getActiveAssignations;
//# sourceMappingURL=Assignation.js.map